import React, { FC } from 'react';
import { WarningFilled } from '@ant-design/icons';
import { SearchHighlight } from '../../connected';
import { readableNumberOfDays } from '../../../utils';

interface Props {
  dangerColor: string
  date: string
  daysUntilDueDate: number
  danger: boolean
}

const WarningDateTime: FC<Props> = ({
  dangerColor,
  date,
  daysUntilDueDate,
  danger,
}) => (date
  ? (
    <div style={{ color: danger ? dangerColor : '#000' }}>
      <SearchHighlight
        text={
        `
          ${date}
          ${daysUntilDueDate ? `(${readableNumberOfDays(daysUntilDueDate)})` : ''}
        `
      }
      />
      {danger && <WarningFilled style={{ marginLeft: 6 }} />}
    </div>
  ) : <span>Unknown</span>);

export default WarningDateTime;
